import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dashboard"];

  connect() {
    $("tr[data-link]").click(function () {
      $.ajax({
        dataType: "script",
        url: $(this).data("link"),
      });
    });
  }

  dashboardTargetConnected() {
    if (window.location.search.includes("get_referral_modal")) {
      const urlParams = new URLSearchParams(window.location.search);
      const referralId = urlParams.get("get_referral_modal");
      if (referralId) {
        $.ajax({
          url: ` /referrals/${referralId}/get_referral_modal`,
          method: "GET",
          remote: true,
          success: function (data) {},
        });
      }
    }

    $('#snooze_referral_toggle').on('change', (e) => {
      const form = $(e.target).closest('form')[0];
      form?.requestSubmit();
    })
  }

  changeProvider(e) {
    const value = e.target.innerText;
    $(`#modal_show_referral #dropdownMenuProvider`)[0].innerHTML = value;
  }

  handleClose() {
    $(`#modal_show_referral`).on("hidden.bs.modal", function () {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete('referral_id');
      urlParams.delete('get_referral_modal');
      window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
      window.location.reload();
    });
  }

  handleOpen(e) {
    if($(e.target).hasClass('has-action') || $(e.target.closest('.has-action')).length) {
      return;
    }

    const {
      params: { id, url, direction, read, notificationId },
    } = e;

    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('referral_id', id);
    window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);

    if (url) {
      $.ajax({
        method: "POST",
        url: url,
        success: function (data) {},
      });
    }

    $.ajax({
      url: `/referrals/${id}/get_referral_modal`,
      data: { direction: direction, read: read, notification_id: notificationId},
      method: "GET",
      remote: true,
      success: function (data) {},
    });
  }

  snoozeReferral(e) {
    e.preventDefault();
  
    let {
      params: { id, date },
    } = e;
    
    // If date is "Remove", set date to null to remove the snooze
    let dateToSend;
    
    if(date === 'Remove') {
      dateToSend = null;
    } else if(date == 'Custom') {
      const dateField = document.querySelector('#modal_snooze_referral_reminder #snooze_reminder_date');
      const error = this.customReminderDateError(dateField);
      if (error) {
        this.showCustomReminderDateError(dateField, error);
        return;
      }
      dateToSend = dateField.value;
    } else{
      let dateToAdd = 1;
      switch(date) {
        case('1 Day'): dateToAdd = 1; break;
        case('1 Week'): dateToAdd = 7; break;
        case('2 Weeks'): dateToAdd = 14; break;
        case('1 Month'): dateToAdd = 30; break;
        default: dateToAdd = 365; break;
      }
      const _date = new Date();
      _date.setDate(_date.getDate() + dateToAdd)
      dateToSend = this.getFormattedDate(_date)
    }
  
    if(dateToSend === undefined) return; // Allow null to proceed, but not undefined
  
    $.ajax({
      url: `/referrals/${id}/snooze_referral`,
      data: { snoozed_until: dateToSend },
      method: "PUT",
      remote: true,
      success: function (data) {
        if(data.status == 'success') {
          // Update the icon in the referral list view
          const clockIcon = $('.snooze-button[data-referral-id-param=' + id + '] > i');
          if (dateToSend === null) {
            // If we removed the snooze
            clockIcon.removeClass('text-primary fa-solid')
              .addClass('fa-regular')
              .attr('title', '')
              .attr('data-bs-original-title', '') 
              .tooltip('dispose');
            // Hide the clock icon in the header if we're on details page
            $('.snooze-indicator').addClass('d-none');

            // Update in More Actions dropdown
            $('.more-actions-snooze-icon')
              .removeClass('fa-solid text-primary')
              .addClass('fas text-sindi-gray');
          } else {
            const [year, month, day] = dateToSend.split('-');
            const formattedDate = new Date(year, month - 1, day).toLocaleDateString('en-US', { 
              month: 'short', 
              day: 'numeric', 
              year: 'numeric' 
            });
            // If we added a snooze - update list view
            clockIcon.addClass('text-primary fa-solid')
              .removeClass('fa-regular')
              .attr('title', `Snoozed until ${formattedDate}`)
              .attr('data-bs-original-title', `Snoozed until ${formattedDate}`) 
              .attr('data-bs-toggle', 'tooltip');
              
            clockIcon.tooltip('dispose');
            clockIcon.tooltip();
              
            const headerClockIcon = $('.snooze-indicator');
            if (headerClockIcon.length > 0) {
              headerClockIcon.removeClass('d-none')
                .attr('title', `Snoozed until ${formattedDate}`)
                .attr('data-bs-original-title', `Snoozed until ${formattedDate}`) 
                .attr('data-bs-toggle', 'tooltip');
              headerClockIcon.tooltip('dispose');
              headerClockIcon.tooltip();
            }

            // Update in More Actions dropdown
            $('.more-actions-snooze-icon')
              .removeClass('fas text-sindi-gray')
              .addClass('fa-solid text-primary');
          }
        }
        
        if($('#modal_snooze_referral_reminder').hasClass('show')) {
          $('#modal_snooze_referral_reminder').modal('hide');
        }
      },
    });
  }

  showSnoozeCustomReminder(e) {
    e.preventDefault();
    const {
      params: { id, date },
    } = e

    this.clearCustomReminderDateError();
    $('#modal_snooze_referral_reminder').modal('show');
    $('#modal_snooze_referral_reminder button').attr('data-referral-id-param', id);
  }

  // Returns an error message for the custom reminder date, or null when valid.
  // Empty dates and dates before today are rejected (flatpickr's minDate blocks
  // the picker, but allowInput lets a past date be typed in).
  customReminderDateError(dateField) {
    const value = (dateField?.value || '').trim();
    if (!value) return 'Please select a date';

    const today = this.getFormattedDate(new Date());
    if (value < today) return 'Date cannot be in the past';

    return null;
  }

  showCustomReminderDateError(dateField, message) {
    this.clearCustomReminderDateError();
    const container = dateField.closest('.date-input');
    const visibleInput = dateField._flatpickr?.altInput || dateField;

    container.classList.add('field-error');
    visibleInput.classList.add('is-invalid');

    const errorEl = document.createElement('div');
    errorEl.className = 'field-error-message';
    errorEl.textContent = message;
    // Append inside the container (its parent is a flex row, so a sibling would
    // sit beside the field). The floating label is anchored to the top, so the
    // extra height doesn't shift it.
    container.appendChild(errorEl);

    const clear = () => this.clearCustomReminderDateError();
    visibleInput.addEventListener('input', clear, { once: true });
    dateField.addEventListener('change', clear, { once: true });
  }

  clearCustomReminderDateError() {
    const modal = document.querySelector('#modal_snooze_referral_reminder');
    if (!modal) return;
    modal.querySelectorAll('.field-error-message').forEach((el) => el.remove());
    modal.querySelectorAll('.field-error').forEach((el) => el.classList.remove('field-error'));
    modal.querySelectorAll('.is-invalid').forEach((el) => el.classList.remove('is-invalid'));
  }

  getFormattedDate(date) {
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');

    return year + '-' + month + '-' + day;
  }

  getDetails(event) {
    if ($(event.target).closest('.snooze-menu').length) {
      // Prevent the default behavior for snooze menu clicks
      event.preventDefault();
    } else {
      const { path, id } = event.params;
      const link = document.createElement("a");
      link.href = path;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    
  }

  submitFormReassignProvider(event) {
    const { status, type, referralId } = event.target.dataset;

    if (status === 'declined') {
      if (type === 'referred_provider') {
        const referring_provider_id = $('#referral_referring_provider_id').val()
        const referred_provider_id = $('#referral_referred_provider_id').val()
        window.location.href = `/referrals/new?referring_provider_id=${referring_provider_id}&referred_provider_id=${referred_provider_id}&referring_referral_id=${referralId}`;
      }
      return;
    }

    event.target.closest('form').submit()
    setTimeout(() => {
      window.location.reload();
    },2000)
  }
}
